import script from "./growth-integraes.vue?vue&type=script&setup=true&lang=js"
export * from "./growth-integraes.vue?vue&type=script&setup=true&lang=js"

import "./growth-integraes.vue?vue&type=style&index=0&id=f1d258d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1d258d8"]])

export default __exports__